import cdrSlice from "../slices/cdrSlice";

export const { RequestCleanFile, SuccessCleanFile, FailureCleanFile, ClearCleanFileId } =
  cdrSlice.actions;
